import React from "react";
import {Box, Chip, Colors, Text} from "@bounce/shared/ui";
import {ParamSchema} from "../../../apis/requests/segments/types";
import ConditionsCard from "../../segments/segment-form/ConditionsCard";
import FormSection from "./FormSection";

const DEFAULT_CONDITIONS_HELP = "The default test is the fallback for every transaction, so it cannot have conditions.";
const MATCHES_ALL_LABEL = "Matches all transactions";
const NO_PARAMETERS_TEXT = "Condition parameters are unavailable.";

type Props = {
  description: string;
  parameters: ParamSchema[];
  isError: boolean;
  isLocked?: boolean;
};

const ConditionsSection = ({description, parameters, isError, isLocked = false}: Props) => {
  if (isLocked) {
    return (
      <FormSection title="Conditions" help={DEFAULT_CONDITIONS_HELP}>
        <Box>
          <Chip size_="small" variant_="inherit" label={MATCHES_ALL_LABEL} />
        </Box>
      </FormSection>
    );
  }

  return (
    <Box sx={{display: "flex", flexDirection: "column", gap: 1}}>
      <ConditionsCard parameters={parameters} description={description} />
      {isError && (
        <Text size={12} sx={{color: Colors.red._900}}>
          {NO_PARAMETERS_TEXT}
        </Text>
      )}
    </Box>
  );
};

export default ConditionsSection;
